import { useEffect, useState } from "react";
import { initPlayer, queryImage } from "./player";

function Mongen({ dna, lock, style }) {
  const [img, setImg] = useState(null);
  useEffect(() => {
    initPlayer();
  }, []);

  useEffect(() => {
    queryImage(dna, (img) => {
      setImg(img);
    });
    return () => { };
  }, [dna, lock]);
  return img === null ? <div></div> : <img className="max-h-full mx-auto" style={{ style }} src={img} alt="mongen" />;
}

export default function StaticAnim({
  dna,
  lock,
}) {
  // console.log(dna)
  if (dna.length === 2) {
    return <></>;
  } else {
    return (
      <Mongen
        lock={lock}
        dna={dna}
      />
    );
  }
}